import { render, staticRenderFns } from "./FooterInfo.vue?vue&type=template&id=4237be71&"
import script from "./FooterInfo.vue?vue&type=script&lang=js&"
export * from "./FooterInfo.vue?vue&type=script&lang=js&"
import style0 from "./FooterInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports